export const highlightMatch = (text: string, query: string) => {
  if (!query) return text

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escapedQuery})`, 'i')

  return text.split(new RegExp(`(${escapedQuery})`, 'ig')).map((part, i) =>
    regex.test(part) ? (
      <mark key={i} style={{ fontWeight: 'bold', backgroundColor: '#ffe58a', padding: '0 1px' }}>
        {part}
      </mark>
    ) : (
      <span key={i}>{part}</span>
    ),
  )
}
